import Model, { attr } from '@ember-data/model';
import { Type } from '@warp-drive/core-types/symbols';
import type { MarketPerformanceMetrics } from 'lumen/models/market-performance/data-item';

// Portfolio-wide totals of one metric type, independent of pagination. The id
// is the metric type (e.g. `otb`, `sdly`); `totals` is null when the metric has
// no value for any property.
export default class MarketPerformanceKpi extends Model {
  [Type] = 'market-performance/kpi' as const;

  @attr() declare totals: MarketPerformanceMetrics | null;
}
